import styled, { css } from 'styled-components/macro';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { Link } from '@yme/components/Link';
import { getTextStyles } from '@yme/utils/styles';
const transitionTime = '0.35s';
export const LinkStyled = styled(Link) `
  text-decoration: unset;
`;
export const FlexAnchorStyled = styled.a `
  width: 100%;
  display: flex;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
`;
export const AnchorStyled = styled.a `
  text-decoration: none;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;
`;
export const ButtonLinkStyled = styled(Link) `
  text-decoration: none;
  width: 100%;
  height: 100%;
`;
export const FlexLinkStyled = styled(Link) `
  width: 100%;
  display: flex;
  text-decoration: none;
`;
export const SVGIconStyled = styled(SVGIcon) `
  position: absolute;
  transition: all ${transitionTime};

  height: 16px;

  ${({ isRightToLeft }) => (isRightToLeft ? 'right: -9px' : 'left: -9px')};

  svg {
    height: 16px;
  }
`;
export const hoverStyles = css `
  &:hover ${SVGIconStyled} {
    ${({ isRightToLeft }) => (isRightToLeft ? 'right: -1px' : 'left: -1px')}
  }
`;
const commonLinkStyles = css `
  text-decoration: unset;
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;

  direction: ${({ isRightToLeft }) => isRightToLeft && 'rtl'};

  ${hoverStyles}
`;
export const ViewAllLinkStyled = styled(Link) `
  ${commonLinkStyles};
  padding: 4px 6px 4px 10px;
`;
export const ReadMoreLinkStyled = styled(Link) `
  ${commonLinkStyles};
  ${getTextStyles(null, null, 16, 24)}
`;
export const IconWrapperStyled = styled.div `
  position: relative;
  width: ${ICON_SIZE.s}px;
  height: ${ICON_SIZE.xxs}px;
  overflow: hidden;
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: 1px' : 'margin-left: 1px')};
`;
